"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CloudProviders_1 = require("./CloudProviders");
exports.cloudProviders = CloudProviders_1.cloudProviders;
exports.Providers = CloudProviders_1.Providers;
exports.RegionContinent = CloudProviders_1.RegionContinent;
exports.RegionCountry = CloudProviders_1.RegionCountry;
exports.RegionFlag = CloudProviders_1.RegionFlag;
var SharedRegexes_1 = require("./SharedRegexes");
exports.bucketNameRegexes = SharedRegexes_1.bucketNameRegexes;
//# sourceMappingURL=main.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/portal-shared-lib/build/main.js
// module id = 44
// module chunks = 1